import {createAction} from '@reduxjs/toolkit'
import {IdStoresStateDataItem, typeStoreFilters} from './dStoresReducer'
import { typePagination, typeRequestPagination } from '../system/constants';

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set data
export const dStoresSetDataAC = createAction(
    'D_STORES_SET_DATA',
    (dataList: IdStoresStateDataItem[]) => ({payload: {dataList}})
)

// Action creator of saga set data
export const dStoresSetDataSagaAC = createAction(
  'D_STORES_SET_DATA_SAGA',
  (
    filters: typeStoreFilters,
    paginationRequest: typeRequestPagination,
    full?: boolean
  ) => ({ payload: { filters, paginationRequest, full } })
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set data detail
export const dStoresSetDetailItemAC = createAction(
    'D_STORES_SET_DETAIL_ITEM',
    (detailItemId: string | undefined) => ({payload: detailItemId})
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of edit data
export const dStoresEditItemAC = createAction(
    'D_STORES_EDIT_ITEM',
    (detailItemObject: IdStoresStateDataItem) => ({payload: detailItemObject})
)

// Action creator of saga edit data
export const dStoresEditItemSagaAC = createAction(
    'D_STORES_EDIT_SAGA_ITEM',
    (detailItemObject: IdStoresStateDataItem,
     filters: typeStoreFilters) => ({payload: {detailItemObject,  filters}})
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of clear filtersForm
export const dStoresClearFiltersAC = createAction(
    'D_STORES_CLEAR_FILTERS',
)

// Action creator of set filtersForm
export const dStoresSetFiltersAC = createAction(
    'D_STORES_SET_FILTERS',
    (filterObj: typeStoreFilters) => ({payload: filterObj})
)


// Action creator of set filtersForm saga
export const dStoresSetFiltersSagaAC = createAction(
    'D_STORES_SET_FILTERS_SAGA',
    ( filtersObject: typeStoreFilters) => ({payload: {filtersObject}})
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set checked item
export const dStoresCheckedItemAC = createAction(
    'D_STORES_CHECK_ITEM',
    (itemId: string) => ({payload: itemId})
)

// Action creator of checked all items
export const dStoresCheckedAllItemAC = createAction(
    'D_STORES_CHECK_ALL_ITEM',
    (value: boolean) => ({payload: value})
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set pagination
export const dStoresSetPaginationAC = createAction(
  'D_STORES_SET_PAGINATION',
  (
    pagination: typePagination,
  ) => ({ payload: { pagination } })
);

// Action creator of set pageNumber in pagination
export const dStoresSetPageNumberAC = createAction(
  'D_STORES_SET_PAGE_NUMBER',
  (
    pageNumber: number,
  ) => ({ payload: { pageNumber } })
)

export const dStoresSetItemsForPageAC = createAction(
  'D_STORES_SET_ITEMS_FOR_PAGE',
  (
    itemsForPage: number,
  ) => ( { payload: { itemsForPage } } )
)